import React from "react";
import HeadPhone from '../assets/img/headphones.svg';
import './css/Login.scss';
import {Link} from "react-router-dom";

class Login extends React.Component{
    render() {
        return(
            <section id="main">
                    <div className="nav-item">
                        <a className="navbar-brand" href="/">Musify</a>
                    </div>
                    <div className="main-row">
                        <div className="main-row-img">
                            <img className="head-phone-img" src={HeadPhone} alt=""/>
                        </div>
                        <div className="main-row-text">
                            <h1>Best Music Online</h1>
                            <p><b>MUSIFY</b> - join now for <b>FREE</b></p>
                            <Link to={"/home"} className="btn">
                                GO TO MUSIFY
                            </Link>
                        </div>
                    </div>
            </section>
        );
    }
}

export default Login;